import React from 'react';
import styled from "styled-components";
import {Result} from "antd";
import {useIntl, defineMessages} from "react-intl";
import {CustomButton} from "../../../../../components/UI/AntCustom/CustomButton";

const BlockedAccessScreenMessages = defineMessages({
  title: {
    id: "blockedAccessScreen.title",
    defaultMessage: "Access Restricted",
  },
  description: {
    id: "blockedAccessScreen.description",
    defaultMessage: "Your subscription payment has not been processed. Please update your payment method to restore access to all features.",
  },
  updatePaymentMethod: {
    id: "blockedAccessScreen.updatePaymentMethod",
    defaultMessage: "Update Payment Method",
  },
  contactSupport: {
    id: "blockedAccessScreen.contactSupport",
    defaultMessage: "Contact Support",
  },
});

const ScreenContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 24px;
`;

interface IBlockedAccessScreen {
  onUpdatePaymentMethod: () => void;
  onContactSupport?: () => void;
}

export const BlockedAccessScreen: React.FC<IBlockedAccessScreen> = ({
  onUpdatePaymentMethod,
  onContactSupport,
}) => {
  const intl = useIntl();

  const handleContactSupport = () => {
    if (onContactSupport) {
      onContactSupport();
    } else {
      // Default: open mailto link
      window.location.href = 'mailto:support@jetsnode.com?subject=Payment Issue - Access Restricted';
    }
  };

  return (
    <ScreenContainer>
      <Result
        status="error"
        title={intl.formatMessage(BlockedAccessScreenMessages.title)}
        subTitle={intl.formatMessage(BlockedAccessScreenMessages.description)}
        extra={[
          <CustomButton
            key="update"
            type="primary"
            onClick={onUpdatePaymentMethod}
          >
            {intl.formatMessage(BlockedAccessScreenMessages.updatePaymentMethod)}
          </CustomButton>,
          <CustomButton
            key="support"
            onClick={handleContactSupport}
          >
            {intl.formatMessage(BlockedAccessScreenMessages.contactSupport)}
          </CustomButton>,
        ]}
      />
    </ScreenContainer>
  );
};
